<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
    parentPage?: boolean
    items?: {
      title: string
      description: string
      icon?: string
    }[]
  }>(),
  {
    title:
      'Keunggulan Integrasi API <span class="text-primary">KiriminAja</span>',
    description: undefined,
    items: () => [
      {
        title: 'Modern REST API',
        description:
          'Menggunakan teknologi REST API terbaru yang lebih mudah dipahami.',
        icon: 'material-symbols:code'
      },
      {
        title: 'White Label Resi',
        description:
          'Branding resi pengiriman oleh bisnismu sendiri tanpa perlu sertakan logo KiriminAja.',
        icon: 'material-symbols:language'
      },
      {
        title: 'Ongkir Akurat',
        description:
          'Informasi ongkir langsung terupdate dari semua ekspedisi yang terhubung.',
        icon: 'material-symbols:pin-drop-outline'
      },
      {
        title: 'Pelacakan Terpusat',
        description:
          'Data pelacakan dari semua ekspedisi terhubung ke dalam toko online-mu.',
        icon: 'material-symbols:my-location'
      },
      {
        title: 'Support Developer',
        description:
          'Siap membantu jika ada kesulitan dalam sistem kapan saja.',
        icon: 'material-symbols:support-agent'
      },
      {
        title: 'Klaim Terintegrasi',
        description:
          'Pengajuan klaim paket yang rusak atau hilang terintegrasi dengan ekspedisi.',
        icon: 'material-symbols:link'
      }
    ]
  }
)
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        :title="title"
        :description="description"
      />

      <div
        class="grid grid-cols-1 gap-6"
        :class="[parentPage ? 'lg:grid-cols-3' : 'lg:grid-cols-4']"
      >
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="33px"
          :title="item.title"
          :description="item.description"
        />
      </div>

      <CtaBase v-if="parentPage" />
    </UiContainer>
  </section>
</template>
